var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "configuration-page" }, [
    _c("p", { staticClass: "breadcrumb" }, [
      _c("button", { on: { click: _vm.goBack } }, [_vm._v("< Back")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: " configuration-container" }, [
      _c("div", { staticClass: "inputs-container" }, [
        _c("p", { staticClass: "main-title" }, [
          _vm._v("Customize your email")
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        !_vm.multipleNotificationDate
          ? _c("div", { staticClass: "date-container" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v("Select the date you’d like to email")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "date-input" },
                [
                  _c("DatePicker", {
                    attrs: {
                      color: "teal",
                      "trim-weeks": "",
                      "min-date": new Date(),
                      attributes: _vm.calendarAttrs
                    },
                    model: {
                      value: _vm.selectedDate,
                      callback: function($$v) {
                        _vm.selectedDate = $$v
                      },
                      expression: "selectedDate"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "date-details" }, [
                    _c("div", { staticClass: "date-detail" }, [
                      _c("p", { staticClass: "circle teal" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "date-copy" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("Recipients Notification Date:")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "subtitle" }, [
                          _vm._v(_vm._s(_vm.currentDateString))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "date-detail" }, [
                      _c("p", { staticClass: "circle indigo" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "date-copy" }, [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("Estimated Delivery Window:")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "subtitle" }, [
                          _vm._v(_vm._s(_vm.estimatedShippingDate))
                        ])
                      ])
                    ])
                  ])
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "message-container" }, [
          _c("p", { staticClass: "title" }, [
            _vm._v("Write your custom message")
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.message,
                expression: "message"
              }
            ],
            attrs: {
              placeholder: "Start typing here...",
              cols: "30",
              rows: "3",
              id: "message"
            },
            domProps: { value: _vm.message },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.message = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "add-gift" }, [
          _c("p", { staticClass: "title" }, [_vm._v("Add a gif or image")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "categories-container" },
            _vm._l(_vm.allOccasions, function(occasion) {
              return _c(
                "button",
                {
                  key: occasion,
                  class: occasion == _vm.selectedOccasion ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.selectOccasion(occasion)
                    }
                  }
                },
                [_vm._v(_vm._s(occasion))]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "gifs-container" },
            [
              _vm._l(_vm.currentGifs, function(gif) {
                return _c(
                  "div",
                  {
                    key: gif.src + gif.occasion,
                    staticClass: "loading",
                    class: gif.src == _vm.selectedGif ? "selected" : "",
                    on: {
                      click: function($event) {
                        return _vm.selectGif(gif.src)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "lazyload",
                      attrs: {
                        width: "150",
                        height: "150",
                        "data-src": gif.src
                      }
                    })
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "upload-gif", attrs: { for: "gif" } },
                [
                  _c("img", {
                    attrs: {
                      src:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/upload.svg?v=1706904622"
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "file-uploader",
                    attrs: { id: "gif", type: "file", accept: "image/*" },
                    on: { change: _vm.fileChange }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("Click to Upload")])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "no-gif",
                  class: _vm.selectedGif == null ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.selectGif(null)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/noimage.svg?v=1706904622"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("No Image")])
                ]
              )
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "add-logo" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "directions-container" }, [
            _c("div", [
              _c("p", { staticClass: "directions-title desktop" }, [
                _vm._v("Upload image here")
              ]),
              _vm._v(" "),
              _c("input", {
                staticClass: "file-uploader",
                attrs: { id: "logo", type: "file", accept: "image/*" },
                on: { change: _vm.fileLogoChange }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "logo" } }, [
                _vm._v("Choose File "),
                _c("img", {
                  staticClass: "lazyload",
                  attrs: {
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/upload_purple.svg?v=1710535518"
                  }
                })
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "mobileFlex preview",
            on: {
              click: function() {
                _vm.expanded = !_vm.expanded
              }
            }
          },
          [
            _vm._v("Preview Email "),
            _c("img", {
              staticClass: "letter",
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/preview.png?v=1720557362",
                alt: "letter"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "preview-container",
          class: _vm.expanded ? "expanded" : ""
        },
        [
          _c("img", {
            staticClass: "remove lazyload mobile",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652"
            },
            on: {
              click: function() {
                _vm.expanded = !_vm.expanded
              }
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "title desktop" }, [_vm._v("Email Preview")]),
          _vm._v(" "),
          _c("div", { staticClass: "blue-container" }, [
            _c("div", { staticClass: "mail-preview" }, [
              this.logoSelected && this.logoUpload
                ? _c("img", {
                    staticClass: "hb-logo",
                    attrs: { src: _vm.selectedLogo }
                  })
                : _c("div", { staticClass: "logo-placeholder" }, [
                    _c("img", { attrs: { src: _vm.selectedLogo } })
                  ]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _vm.message == ""
                ? _c("div", { staticClass: "message-placeholder" }, [
                    _c("span", [_vm._v("Your message here")])
                  ])
                : _c("p", { staticClass: "mail-message" }, [
                    _vm._v(_vm._s(_vm.message))
                  ]),
              _vm._v(" "),
              _vm.selectedGif
                ? _c("img", {
                    staticClass: "mail-gif",
                    attrs: { src: _vm.selectedGif }
                  })
                : _c("div", { staticClass: "gif-placeholder" }, [
                    _c("span", [_vm._v("Gif")])
                  ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "recipients-container" }, [
            _c("p", { staticClass: "recipient-title" }, [_vm._v("Recipients")]),
            _vm._v(" "),
            _c("div", { staticClass: "shipped-table" }, [
              _c("table", [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Name")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Email")]),
                    _vm._v(" "),
                    _vm.multipleNotificationDate
                      ? _c("th", [_vm._v("Notification Date")])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("th", [_vm._v("From")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.emailFileData, function(recipient) {
                    return _c("tr", { key: recipient.email }, [
                      _c("td", [
                        _vm._v(
                          _vm._s(recipient.firstName) +
                            " " +
                            _vm._s(recipient.lastName)
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(recipient.email))]),
                      _vm._v(" "),
                      _vm.multipleNotificationDate
                        ? _c("td", [
                            _vm._v(
                              _vm._s(
                                recipient.notificationDate
                                  .toLocaleString("en-US")
                                  .split("T")[0]
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(recipient.from))])
                    ])
                  }),
                  0
                )
              ])
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sticky-container" }, [
      _c(
        "button",
        {
          staticClass: "happybox-button green border",
          class: _vm.isLoading ? "isLoading" : "",
          on: {
            click: function($event) {
              return _vm.createGifts()
            }
          }
        },
        [_vm._v(_vm._s(_vm.buttonText))]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "main-subtitle" }, [
      _vm._v("Your recipient will "),
      _c("strong", [_vm._v("receive an email")]),
      _vm._v(" prompting them to "),
      _c("strong", [_vm._v("redeem their gift")]),
      _vm._v(
        ". Pick a header, write your message and schedule when you’d like us to notify them and we’ll handle the rest."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _vm._v("Add your logo or custom graphic "),
      _c("span", [_vm._v("(optional)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mail-title" }, [
      _vm._v("\n                            Hey "),
      _c("span", [_vm._v("[Recipient]")]),
      _vm._v(", "),
      _c("span", [_vm._v("[From]")]),
      _vm._v(" sent "),
      _c("br"),
      _vm._v(" you a gift! 🎉\n                        ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }